export default () => ({
  // Constants
  DESKTOP_BREAKPOINT: 1024,

  // State
  isContentVisible: false,
  resizeHandler: null,
  wasDesktop: null,

  init() {
    this.$nextTick(() => {
      this.positionContentWrapper();
      this.wasDesktop = window.innerWidth >= this.DESKTOP_BREAKPOINT;
      this.resizeListener();
    });
  },

  destroy() {
    if (this.resizeHandler) {
      window.removeEventListener("resize", this.resizeHandler);
    }
  },

  resizeListener() {
    this.resizeHandler = () => {
      const isDesktop = window.innerWidth >= this.DESKTOP_BREAKPOINT;
      if (this.wasDesktop !== isDesktop) {
        this.wasDesktop = isDesktop;
        this.positionContentWrapper();
      }
    };

    window.addEventListener("resize", this.resizeHandler);
  },

  positionContentWrapper() {
    const textWrapper = this.$refs.textWrapper;
    if (!textWrapper) return;

    const slideRect = this.$root.getBoundingClientRect();

    // Center content vertically within the slide
    const centeredTopOffset = slideRect.height / 2;
    textWrapper.style.paddingTop = `${centeredTopOffset}px`;

    this.isContentVisible = true;
  },
});
